import { createContext, useContext, useState, type ReactNode } from "react";

type LandlordSettingsContextValue = {
  ownershipId: string;
  setOwnershipId: (id: string) => void;
};

const LandlordSettingsContext = createContext<
  LandlordSettingsContextValue | undefined
>(undefined);

export function LandlordSettingsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [ownershipId, setOwnershipIdState] = useState(() => {
    return localStorage.getItem("landlord_ownership_selector_id") ?? "";
  });
  const setOwnershipId = (id: string) => {
    localStorage.setItem("landlord_ownership_selector_id", id);
    setOwnershipIdState(id);
  };

  return (
    <LandlordSettingsContext.Provider value={{ ownershipId, setOwnershipId }}>
      {children}
    </LandlordSettingsContext.Provider>
  );
}

export function useLandlordSettingsProvider() {
  const ctx = useContext(LandlordSettingsContext);
  if (!ctx) {
    throw new Error(
      "useLandlordSettingsProvider must be inside <LandlordSettingsProvider>",
    );
  }
  return ctx;
}
